function initWheel (container) {
  const windowWidth = window.innerWidth;
  if (windowWidth < 768) {
    return false;
  }

  const wheelElement = container.querySelector('.bg-wheel__wheel');
  const elementHeight = 568;
  const rightSide = container.getAttribute('data-side') === 'right';
  const moveDown = container.getAttribute('data-move') === '1' || false;
  const xPosition = container.getAttribute('data-x-position');
  const boundingClientRect = container.getBoundingClientRect();
  const scrollTopBlock = window.scrollY + boundingClientRect.top;
  const windowHeight = window.innerHeight;
  const startPosition = scrollTopBlock - windowHeight;
  const degCoeff = 360 / (windowHeight + windowHeight + elementHeight) * (rightSide ? 1 : -1);

  function updateState () {
    const scrollTop = window.scrollY;
    let rotateDeg = (scrollTop - scrollTopBlock) * degCoeff;
    let movePercents = 0;
    if (moveDown) {
      movePercents = ((scrollTop - startPosition) * 0.10);
      movePercents = movePercents > 0 ? movePercents : 0;
      rotateDeg = rotateDeg / 2;
    }
    wheelElement.style.transform = `translate(${rightSide ? '' : '-'}${xPosition}%, ${movePercents}%) rotate(${rotateDeg}deg)`;
  }

  window.addEventListener('scroll', updateState);
  updateState();
}

export default function () {
  document.querySelectorAll('.bg-wheel').forEach(initWheel);
}
